// extracted by mini-css-extract-plugin
export default {"spacingRadioGroup":"More18Years_spacingRadioGroup__jK5ge","spacingRadio":"More18Years_spacingRadio__3LDY6"};